import { BaseService } from './base-service';
import {
	GetOccupationalDoctorRequestDTO,
	GetOccupationalDoctorResponseDTO,
	GetListOccupationalDoctorRequestDTO,
	GetListOccupationalDoctorResponseDTO,
	CreateOccupationalDoctorRequestDTO,
	CreateOccupationalDoctorResponseDTO,
	UpdateOccupationalDoctorRequestDTO,
	UpdateOccupationalDoctorResponseDTO,
	DestroyOccupationalDoctorRequestDTO,
	DestroyOccupationalDoctorResponseDTO
} from '@/core/dto';

export class OccupationalDoctorService extends BaseService<any> {
	private static instance: OccupationalDoctorService;

	private constructor(public readonly basePath: string = '/occupational-doctor') {
		super();
	}

	public static getInstance(): OccupationalDoctorService {
		if (!OccupationalDoctorService.instance) {
			OccupationalDoctorService.instance = new OccupationalDoctorService();
		}
		return OccupationalDoctorService.instance;
	}

	public async show(params: GetOccupationalDoctorRequestDTO): Promise<GetOccupationalDoctorResponseDTO> {
		const url = this.basePath + `/${params.id}`;
		const { data } = await this.getInstance().get<GetOccupationalDoctorResponseDTO>(url, { params });
		return data;
	}

	public async index(params: GetListOccupationalDoctorRequestDTO): Promise<GetListOccupationalDoctorResponseDTO> {
		const url = this.basePath + '/';
		const { data } = await this.getInstance().get<GetListOccupationalDoctorResponseDTO>(url, { params });
		return data;
	}

	public async create(params: CreateOccupationalDoctorRequestDTO): Promise<CreateOccupationalDoctorResponseDTO> {
		const url = this.basePath + '/';
		const { data } = await this.getInstance().post<CreateOccupationalDoctorResponseDTO>(url, params);
		return data;
	}

	public async update(params: UpdateOccupationalDoctorRequestDTO): Promise<UpdateOccupationalDoctorResponseDTO> {
		const url = this.basePath + `/${params.id}`;
		const { data } = await this.getInstance().put<UpdateOccupationalDoctorResponseDTO>(url, params);
		return data;
	}

	public async destroy(params: DestroyOccupationalDoctorRequestDTO): Promise<DestroyOccupationalDoctorResponseDTO> {
		const url = this.basePath + `/${params.id}`;
		const { data } = await this.getInstance().delete<DestroyOccupationalDoctorResponseDTO>(url, { params });
		return data;
	}
}
